import React from "react";

import { Navigate, useLocation, useParams } from "react-router-dom";

type LegacyV2RedirectProps = {
  module: string;
};

const LegacyV2Redirect = ({
  module,
}: LegacyV2RedirectProps): React.ReactElement => {
  const { "*": splat, farmId } = useParams();
  const { hash, search } = useLocation();
  const subPath = splat ? `/${splat}` : "";

  return (
    <Navigate
      replace
      to={`/farm/${farmId}/${module}${subPath}${search}${hash}`}
    />
  );
};

export { LegacyV2Redirect };
